import React from 'react';

import TopBanner from './components/TopBanner';
import BrandBanner from './components/BrandBanner';
import OperationBanner from './components/OperationBanner';
import PitchBanner from './components/PitchBanner';
import RentOutBanner from './components/RentOutBanner';
import Footer from '../../components/Footer';

const Owners = () => {
  return (
    <div className="w-full overflow-x-hidden">
      <TopBanner />
      <BrandBanner />
      <OperationBanner />
      <PitchBanner />
      <RentOutBanner />
      <Footer />
    </div>
  )
}

export default Owners;